import TrendEstimationView from "../component/dashboard_data/TrendEstimationView"
import CurrentDataView from "../component/dashboard_data/CurrentDataView"
import LatestDataView from "../component/dashboard_data/LatestDataView"
import DataViewPreferences from "../component/dashboard_data/DataViewPreferences"
import BaselineDataView from "../component/dashboard_data/BaselineDataView"
import { useAppSelector } from "../redux/store/hooks"
import {
    selectDashboardSelectedPatient,
    selectDashboardSelectedValueType,
    selectSelectedDataPoint
} from "../redux/ProfessionalDashboard"
import DashboardWrapper from "../component/DashboardWrapper"
import { useNavigate } from "react-router-dom"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../navigation/NavigationController"
import RequirePatientSelection from "../component/require/RequirePatientSelection"
import RequireValueTypeSelection from "../component/require/RequireValueTypeSelection"
import notNull from "../util/notNull"
import { useEffect, useState } from "react"
import {
    mockPatientUsed,
    mockPhqValueTypeUsed,
    mockSleepValueTypeUsed,
    selectOnboardingIsRunningState,
    selectOnboardingStep
} from "../redux/Onboarding"
import { ArrayElement } from "../types/ArrayElement"
import { GetPatientsOfProfessionalResponsePayload, isActiveValueType, ValueType } from "pokal_api"
import mockPatient from "../onboarding/mock/mockPatient"
import QuestionnaireDetailView from "../component/dashboard_data/QuestionnaireDetailView"
import MoodDetailPanel from "../component/dashboard_data/MoodDetailPanel"
import DataPointNotesPanel from "../component/dashboard_data/DataPointNotesPanel"
import { valueTypeNames } from "../util/valueTypeNames"
import DocumentationComponent from "../component/DocumentationComponent"
import ValueTypeDocumentation from "../documentation/ValueTypeDocumentation"
import DummySFQDetailCard from "../component/dashboard_data/DummySFQDetailCard"

function PatientDetailView() {
    const [selectedPatient, setSelectedPatient] =
        useState<ArrayElement<GetPatientsOfProfessionalResponsePayload> | null>(
            null
        )
    const [selectedValueType, setSelectedValueType] =
        useState<ValueType | null>(null)

    const fetchedSelectedValueType = useAppSelector(
        selectDashboardSelectedValueType
    )
    const fetchedSelectedPatient = useAppSelector(
        selectDashboardSelectedPatient
    )
    // Hook für SFQ-Auswahl immer auf Top-Level!
    const selectedQuestionnaireId = useAppSelector(state => state.professionalDashboard.data.selectedQuestionnaireId)
    const selectedDataPoint = useAppSelector(selectSelectedDataPoint)
    const showNotePanel = !!(
        selectedDataPoint &&
        selectedDataPoint.note &&
        selectedDataPoint.note.trim()
    )

    const navigate = useNavigate()

    const step = useAppSelector(selectOnboardingStep)
    const running = useAppSelector(selectOnboardingIsRunningState)
    useEffect(() => {
        if (mockPatientUsed(running, step)) {
            setSelectedPatient(mockPatient()[0])
            if (mockPhqValueTypeUsed(running, step)) {
                setSelectedValueType(ValueType.PHQUESTIONNAIRE)
            }
            if (mockSleepValueTypeUsed(running, step)) {
                setSelectedValueType(ValueType.SLEEP_DURATION)
            }
        } else {
            setSelectedPatient(fetchedSelectedPatient)
            setSelectedValueType(fetchedSelectedValueType)
        }
    }, [step, running, fetchedSelectedPatient, fetchedSelectedValueType])

    return (
        <RequirePatientSelection>
            <RequireValueTypeSelection>
                {notNull(selectedPatient) && notNull(selectedValueType) && (
                    <DashboardWrapper
                        onClick={() => { navigate(-1) }}
                        title={
                            <>
                                <span>
                                    {selectedPatient.firstName}{" "}
                                    {selectedPatient.lastName}
                                </span>
                                {/* DocumentationComponent entfernt, nur noch Text */}
                                {" "}
                                {valueTypeNames[selectedValueType]}
                            </>
                        }>
                        <div className={"w-full flex flex-col space-y-4"}>
                            {selectedValueType === ValueType.SFQUESTIONNAIRE ? (
                                <>
                                    <div className={"w-full flex flex-row space-x-4"}>
                                        <div className={"flex-1 flex flex-col w-full"}>
                                            <CurrentDataView />
                                        </div>
                                        <div className={"flex-1 flex flex-col w-full"}>
                                            {!selectedQuestionnaireId ? <DummySFQDetailCard /> : <QuestionnaireDetailView />}
                                        </div>
                                    </div>
                                    <div className={"w-full mt-4"}>
                                        <BaselineDataView />
                                    </div>
                                </>
                            ) : (
                                <>
                                    {selectedValueType === ValueType.PHQUESTIONNAIRE && (
                                        <div className={"flex space-x-4"}>
                                            <button
                                                onClick={() => {
                                                    navigate(
                                                        NavigationPaths[
                                                            NAVIGATION_VIEW.PROFESSIONAL_DASHBOARD_PHQ8
                                                        ].path
                                                    )
                                                }}
                                                className={
                                                    "px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
                                                }>
                                                PHQ-8
                                            </button>
                                        </div>
                                    )}
                                    <div className={"w-full flex space-x-4"}>
                                        <div className={"flex-1 flex flex-col w-full"}>
                                            <TrendEstimationView />
                                        </div>
                                        <div className={"flex-3 flex flex-col w-full"}>
                                            <CurrentDataView />
                                        </div>
                                        {isActiveValueType(selectedValueType) && (
                                            <div
                                                className={
                                                    "flex flex-col w-full flex-1 space-y-4"
                                                }>
                                                <LatestDataView />
                                            </div>
                                        )}
                                    </div>
                                    <div className={"flex space-x-4"}>
                                        {isActiveValueType(selectedValueType) ? (
                                            <>
                                                <div className={"flex-1"}>
                                                    <BaselineDataView />
                                                </div>
                                                {selectedValueType === ValueType.MOOD ? (
                                                    <MoodDetailPanel />
                                                ) : (
                                                    <QuestionnaireDetailView />
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                <div className={showNotePanel ? "w-3/4" : "w-full"}>
                                                    <BaselineDataView />
                                                </div>
                                                {showNotePanel && (
                                                    <div className={"w-1/4"}>
                                                        <DataPointNotesPanel />
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </DashboardWrapper>
                )}
            </RequireValueTypeSelection>
        </RequirePatientSelection>
    )
}

export default PatientDetailView
